"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelperText = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _components = require("./components");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  text: _propTypes.string,
  variant: _propTypes.string,
  size: _propTypes.string,
  disabled: _propTypes.bool,
  width: _propTypes.string,
  relatedInputType: _propTypes.string
} : {};

var HelperText = function HelperText(_ref) {
  var text = _ref.text,
      variant = _ref.variant,
      size = _ref.size,
      disabled = _ref.disabled,
      width = _ref.width,
      relatedInputType = _ref.relatedInputType;
  return (0, _core.jsx)(_components.HelperText, {
    variant: variant,
    size: size,
    disabled: disabled,
    width: width,
    relatedInputType: relatedInputType
  }, text);
};

exports.HelperText = HelperText;
HelperText.displayName = 'HelperText';
process.env.NODE_ENV !== "production" ? HelperText.propTypes = propTypes : void 0;